import { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import httpclient from "../../service/httpclient";
import { Button, Collapse, Empty, Space, Spin, Typography } from "antd";
import { ArrowRightOutlined, CaretRightOutlined } from "@ant-design/icons";
import "./recruitment_question_exam_records.scss";
import useWindowWidth from "../../hooks/useWindowWidth";
import moment from "moment";

function AnswerCard({ questions, correctness, goToQuestion, currentQuestion }) {
  const colors = {
    correct: "#8dc7ff",
    partial: "#ffd64c",
    wrong: "#ff7d7d",
    blank: "#c5c5c5",
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        maxHeight: "40vh",
        overflowY: "auto",
      }}
    >
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {questions.map((q, i) => (
          <div
            key={q.id}
            style={{
              display: "inline-block",
              borderRadius: "50%",
              width: 46,
              height: 46,
              backgroundColor: colors[correctness[i].type],
              alignContent: "center",
              textAlign: "center",
              fontSize: i === currentQuestion ? 18 : 16,
              margin: 4,
              transition: "all ease-in-out 0.2s",
              cursor: "pointer",
              border:
                i === currentQuestion
                  ? `3px solid ${colors[correctness[i].type]}`
                  : "3px solid #f4f4f4",
              color: "#00000088",
            }}
            onClick={() => goToQuestion(i)}
          >
            <b>{i + 1}</b>
          </div>
        ))}
      </div>
    </div>
  );
}

function RecordCollapsePanel({ record, index, ...props }) {
  const colors = {
    correct: "#1890ff",
    partial: "#ffbc4c",
    wrong: "#ff7d7d",
    blank: "grey",
  };
  const correctness = record.answers.map(
    ({ format, answer, correct, score }) => {
      if (format === "单选")
        return {
          correct: String.fromCharCode(65 + correct),
          answer: answer !== null ? String.fromCharCode(65 + answer) : "无",
          type: answer === null ? "blank" : score === 2 ? "correct" : "wrong",
          score,
        };
      if (format === "多选")
        return {
          correct: correct.map((a) => String.fromCharCode(65 + a)).join(""),
          answer:
            answer?.map((a) => String.fromCharCode(65 + a))?.join("") || "无",
          type:
            answer === null
              ? "blank"
              : score === 4
              ? "correct"
              : score === 2
              ? "partial"
              : "wrong",
          score,
        };
    }
  );

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const goToQuestion = (index) => {
    setCurrentQuestion((c) =>
      0 <= index && index < record.answers.length ? index : c
    );
  };

  return (
    <Collapse.Panel
      {...props}
      className="exam-records-collapse-panel"
      header={
        <div
          style={{
            display: "inline-block",
            width: "calc(100% - 32px)",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Space direction="vertical" size={2}>
              <b style={{ fontSize: 16 }}>提交记录{index}</b>
              <Space size={[16, 2]} wrap={true}>
                <span>
                  提交时间:{" "}
                  {moment(record.created_at).format("YYYY-MM-DD HH:mm")}
                </span>
                <span>
                  用时: {Math.floor(record.seconds_taken / 60)}分
                  {record.seconds_taken % 60}秒
                </span>
              </Space>
            </Space>
            <b>
              <span>得分：</span>
              <span style={{ color: "#1890ff", fontSize: 28 }}>
                {record.score}
              </span>
              <span style={{ color: "grey", fontSize: 16 }}>/100</span>
            </b>
          </div>
        </div>
      }
    >
      <div style={{ textAlign: "center", margin: "4px 0 18px 0" }}>
        您此次提交的分数超过了最近一周
        <b style={{ color: "#1890ff" }}>{record.percentile}%</b>的提交!
      </div>
      <AnswerCard
        questions={record.answers}
        correctness={correctness}
        currentQuestion={currentQuestion}
        goToQuestion={goToQuestion}
      />
      <div style={{ textAlign: "center", marginTop: 14 }}>
        <Space>
          <span>
            我的答案:{" "}
            <b
              style={{
                color: colors[correctness[currentQuestion].type],
              }}
            >
              {correctness[currentQuestion].answer}
            </b>
          </span>
          <span>
            正确答案:{" "}
            <b style={{ color: "#1890ff" }}>
              {correctness[currentQuestion].correct}
            </b>
          </span>
          <span>
            得分:{" "}
            <b style={{ color: colors[correctness[currentQuestion].type] }}>
              {correctness[currentQuestion].score}
            </b>
          </span>
          <Button
            style={{ padding: 0 }}
            type="link"
            onClick={() =>
              window.open(
                `/recruitment-questions/${record.answers[currentQuestion].id}`,
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            查看原题
            <ArrowRightOutlined />
          </Button>
        </Space>
      </div>
    </Collapse.Panel>
  );
}

function RecruitmentQuestionExamRecordsPage() {
  const { listId } = useParams();
  const [records, setRecords] = useState(null);
  const [list, setList] = useState(null);
  useEffect(() => {
    httpclient
      .getUserRecruitmentQuestionExamRecordsByListId(listId)
      .then((r) => {
        setRecords(r.records);
        setList(r.list);
      });
  }, [listId]);

  const { deviceType } = useWindowWidth();

  return (
    <div className="recruitment-question-exam-records">
      {records && list ? (
        <div style={{ width: deviceType === "pc" ? "80%" : "95%" }}>
          <h2>我的模拟笔试 —— {list.title}</h2>
          <Typography.Paragraph>
            <blockquote>
              模拟笔试总计100分，限时60分钟，具体评分规则：
              <br />
              <ul>
                <li>单选题30题，每题2分，总计60分；选对得2分，选错得0分。</li>
                <li>
                  多选题10题，每题4分，总计40分；全部选对得4分，部分选对得2分，有选错得0分。
                </li>
              </ul>
            </blockquote>
          </Typography.Paragraph>
          <div style={{ marginTop: 24 }}>
            {records.length > 0 ? (
              <Collapse
                className="exam-records-collapse"
                defaultActiveKey={[records.length]}
                bordered={false}
                expandIcon={({ isActive }) => (
                  <div>
                    <CaretRightOutlined rotate={isActive ? 90 : 0} />
                  </div>
                )}
              >
                {records.map((r, index) => (
                  <RecordCollapsePanel
                    key={records.length - index}
                    record={r}
                    index={records.length - index}
                  />
                ))}
              </Collapse>
            ) : (
              <div
                style={{
                  minHeight: "70vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Empty description="还没有提交记录哦" />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div
          style={{
            minHeight: "70vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Spin />
        </div>
      )}
    </div>
  );
}

export default RecruitmentQuestionExamRecordsPage;
